import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Form, FormGroup, Label, Button, Table, Modal} from 'reactstrap';
import { GetPreventativeMaintenanceCustomFields,DeletePMCustomField,OpenAddCustomPopup,UpdatePMCustomFieldsOrder } from 'action/workorderAction';
import DeleteIcon from '../../../../Assets/images/Icons__trash2.svg';
import classnames from 'classnames';
import DeleteConfirmation from './WorkOrderDeleteConfirmation';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Ref } from "semantic-ui-react";
import { MdDragHandle } from 'react-icons/md';

const headinglabel = {
    fontfamily: 'Lato',
    fontSize: '14px',
    fontWeight: 'bold',
    'margin-left':'15px'
};


class PreventativeMaintenanceCustomFields extends Component {

    
    constructor(props) {
        super(props);
        this.state = {
            deletemodal: false,  
            DeleteFieldId: 0 ,
            Options_List_Value : []         
        };
      
    }

    componentWillMount(){
        this.props.GetPMCustomFields();
    }

    componentWillReceiveProps(nextProps){
        if(this.props !== nextProps && nextProps.getCustomFields !== undefined && nextProps.getCustomFields !== null)
        {
            var fieldsFromDB = nextProps.getCustomFields;
            var Options_List_Value = fieldsFromDB.map(el => ({
                fieldName: el.fieldName,
                fieldLabel: el.fieldLabel,
                fieldId: el.fieldId,
                fieldType: el.fieldType,
                value: (el.value !== null && el.value.length > 0 ) ? el.value : "--", 
                shortValue: "--",               
                display: el.display ,
                required: el.required,
                orderId: el.orderId
            }));

            Options_List_Value.forEach(el => {
                if ( el.value !== null && el.value !== "--") {
                    let sortedData = el.value.sort((a, b) => {
                        var nameA = a['orderId'];
                        var nameB = b['orderId'];
                        if (nameA < nameB) { return -1; }
                        if (nameA > nameB) { return 1; }
                        if (nameA === nameB) { return 0; }
                        return 0;
                    });
                    var short_text = sortedData.map(el => (
                        el.value
                    ));
                    el.shortValue = short_text.join(', ').substring(0, 30) + (short_text.join(', ').length > 30 ? "..." : "")
                }
            });
            var l_Options_List_Value = this.OnSort(Options_List_Value);
            this.setState({ Options_List_Value: l_Options_List_Value }); 
        }
    }

    OpenAddCustomPopup(FieldId){
        this.props.OpenAddCustomPopup(true,FieldId);
    }

    Delete = (someArg) => {
        if (someArg === "yes") {        
            this.props.DeletePMCustomField(this.state.DeleteFieldId);
        }
        this.Deletetoggle();
    }

    DeletePMCustomField(fieldId) {
        this.setState({
            DeleteFieldId : fieldId
        });
        this.Deletetoggle();
    }

    Deletetoggle() {
        this.setState({
            deletemodal: !this.state.deletemodal
        });
    }

    onDragEnd = result => {
        const { destination, source, reason } = result;
    
        // Not a thing to do...
        if (!destination || reason === 'CANCEL') {
          return;
        }
    
        if(destination.droppableId === source.droppableId && destination.index === source.index) 
        {
          return;
        }
    
        const entities = Object.assign([], this.state.Options_List_Value);
        const quote = this.state.Options_List_Value[source.index];
        entities.splice(source.index, 1);
        entities.splice(destination.index, 0, quote);
    
        this.setState({ Options_List_Value : entities });
        var ReorderedData = [];
        entities.forEach((el,index) => {
            ReorderedData.push({"FieldId":el.fieldId,"OrderId":index + 1});
        });
        this.props.UpdatePMCustomFieldsOrder(ReorderedData);
    }

    getItemStyle = (isDragging, draggableStyle) => ({
        background: isDragging && ("lightblue"),
        ...draggableStyle,
    })

    OnSort(values) {
        if(values !== undefined && values !== null && values !== "--"){
            const sorted_data = values.sort((a, b) => {
                let nameA, nameB;
                nameA = a.orderId;
                nameB = b.orderId;
                return (nameA - nameB);
            });
            return sorted_data;
        }
    }

    render(){
        let label = this.props.getLabels;
        var IsNotEmpty = false;
        if(this.state.Options_List_Value !== undefined && this.state.Options_List_Value !== null && this.state.Options_List_Value.length > 0)
        { 
            IsNotEmpty = true;
        }        
        return(
            <div style={{marginTop:'30px'}}>
                <Form>
                    <FormGroup>
                        <Label style={headinglabel}>{label['WorkOrderSetup.CustomField.Text']}</Label>
                        <Button style={{'float':'right'}} className="child_tab_button" onClick={() => { this.OpenAddCustomPopup(-1) }}>{label['WorkOrderSetup.Custom.Button.Text'] !== undefined ? label['WorkOrderSetup.Custom.Button.Text'] : "ADD CUSTOM FIELD"}</Button>
                    </FormGroup>
                </Form>
                {
                    !IsNotEmpty ?
                        <div className="table_container table_border">
                            <Table striped responsive className="Custom_table fixed_layout">
                                <tbody className="cell_container">
                                    <tr>
                                        <th><span>{label['WorkOrderSetup.Header.FieldName.Text']}</span></th>
                                        <th><span>{label['WorkOrderSetup.Header.FieldLabel.Text']}</span></th>
                                        <th><span>{label['WorkOrderSetup.Header.FieldType.Text']}</span></th>
                                        <th><span>{label['WorkOrderSetup.Header.Values.Text']}</span></th>
                                        <th><span>{label['WorkOrderSetup.Header.Required.Text']}</span></th>
                                        <th><span>{label['WorkOrderSetup.Header.DisplayOnPage.Text']}</span></th>
                                    </tr>
                                    <tr><td colSpan="6">{label['WorkOrders.Table.Default.Text']}</td></tr>
                                </tbody>
                            </Table>
                        </div> :
                        <div className="table_container table_border">
                            <DragDropContext onDragEnd={this.onDragEnd}>
                                <table className="Custom_table fixed_layout table table-striped">
                                    <thead className="cell_container">
                                        <tr>
                                            <th><span style={{"padding-left":"37px"}}>{label['WorkOrderSetup.Header.FieldName.Text']}</span></th>
                                            <th><span>{label['WorkOrderSetup.Header.FieldLabel.Text']}</span></th>
                                            <th><span>{label['WorkOrderSetup.Header.FieldType.Text']}</span></th>
                                            <th><span>{label['WorkOrderSetup.Header.Values.Text']}</span></th>
                                            <th><span>{label['WorkOrderSetup.Header.Required.Text']}</span></th>
                                            <th><span>{label['WorkOrderSetup.Header.DisplayOnPage.Text']}</span></th>
                                        </tr>
                                    </thead>
                                    <Droppable droppableId="tableBody">
                                        {(provided, snapshot) => (
                                            <Ref innerRef={provided.innerRef}>
                                                <tbody className="cell_container" {...provided.droppableProps}>
                                                    {this.state.Options_List_Value.map((entity, index) => (
                                                        <Draggable draggableId={entity.fieldId.toString()} index={index} key={entity.fieldId} >
                                                            {(provided, snapshot) => (
                                                                <Ref innerRef={provided.innerRef}>
                                                                    <tr {...provided.draggableProps} {...provided.dragHandleProps} style={this.getItemStyle(snapshot.isDragging, provided.draggableProps.style)} >
                                                                        <td><MdDragHandle /><Label className="link_cursorUnderline" onClick={() => { this.OpenAddCustomPopup(entity.fieldId) }}>{entity.fieldName}</Label></td>
                                                                        <td>{entity.fieldLabel}</td>
                                                                        <td>{entity.fieldType ? label['WorkOrderSetup.SingleDropdown.Text'] : label['WorkOrderSetup.TextArea.Text']}</td>
                                                                        <td>{entity.shortValue !== null && entity.shortValue !== "" ? entity.shortValue : "--"}</td>
                                                                        <td>{entity.required ? label['WorkOrderSetup.Yes.Text'] : label['WorkOrderSetup.No.Text']}</td>
                                                                        <td style={{"cursor":"pointer"}}>
                                                                            {entity.display === true ? label['WorkOrderSetup.Yes.Text'] : label['WorkOrderSetup.No.Text']}
                                                                            <img src={DeleteIcon} onClick={() => { this.DeletePMCustomField(entity.fieldId) }} style={{ width: '18px', float: 'right', valign: 'bottom', marginRight: '15px' }} className="link_cursor" alt="DeleteIcon" />
                                                                        </td>
                                                                    </tr>
                                                                </Ref>
                                                            )}
                                                        </Draggable>
                                                    ))}
                                                    {provided.placeholder}
                                                </tbody>
                                            </Ref>
                                        )}
                                    </Droppable>
                                </table>
                            </DragDropContext>
                        </div>
                }
                <Modal isOpen={this.state.deletemodal} deletemodal={this.deletemodal} className={classnames({ classnames: this.props.className }, "ModalContainer short_modal")} >
                    <DeleteConfirmation parentToChildData={["Delete Custom Field", "You are about to delete a custom field from the system. This custom field might be associated to existing PM. Do you want to continue? ", "Close Window", "Delete Custom Field"]} Delete={this.Delete} />
                </Modal>
            </div>
        )
    }
};

const mapStateToProps = (state) => {
    return{
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
        getCustomFields: state.WorkorderRootReducer.PreventativeMaintenanceCustomFields
    }
};

const mapDispatchToProps = (dispatch) => {
    return{
        GetPMCustomFields : () => dispatch(GetPreventativeMaintenanceCustomFields()),
        DeletePMCustomField: (fieldId) => dispatch(DeletePMCustomField(fieldId)),
        OpenAddCustomPopup: (data,fieldId) => dispatch(OpenAddCustomPopup(data,fieldId)),
        UpdatePMCustomFieldsOrder: (data) => dispatch(UpdatePMCustomFieldsOrder(data))
    }
};

export default connect(mapStateToProps,mapDispatchToProps)(PreventativeMaintenanceCustomFields);